/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  getForm,
  createValidateObject,
  storeRecoveryFieldValues,
  storeSetFieldValue,
  storeSetFieldsErrors
} from '../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const LOAD_FORM_DATA = 'LOAD_FORM_DATA';
const SEND_FORM = 'SEND_FORM';
const RECOVERY_FIELDS = 'RECOVERY_FIELDS';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';

const CHANGE_FIELD_NAME = 'CHANGE_FIELD_NAME';
const CHANGE_FIELD_BIRTH_DATE = 'CHANGE_FIELD_BIRTH_DATE';
const CHANGE_FIELD_BIRTH_MONTH = 'CHANGE_FIELD_BIRTH_MONTH';
const CHANGE_FIELD_BIRTH_YEAR = 'CHANGE_FIELD_BIRTH_YEAR';
const CHANGE_FIELD_GENDER = 'CHANGE_FIELD_GENDER';
const CHANGE_FIELD_CITY_GEONAME_ID = 'CHANGE_FIELD_CITY_GEONAME_ID';
const CHANGE_FIELD_TIME_ZONE = 'CHANGE_FIELD_TIME_ZONE';
const CHANGE_FIELD_CONSENT_TO_ADULT_CONTENT =
  'CHANGE_FIELD_CONSENT_TO_ADULT_CONTENT';

const SET_CITY_GEONAME_ITEM_SELECTED = 'SET_CITY_GEONAME_ITEM_SELECTED';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      cityGeonameItemSelected: {
        value: null,
        title: null
      },
      fields: {
        name: {
          title: 'Имя',
          inValue: '',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        date: {
          title: 'Дата рождения',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        month: {
          title: 'Месяц рождения',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        year: {
          title: 'Год рождения',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        gender: {
          title: 'Пол',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        city_geoname_id: {
          title: 'Местоположение',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        time_zone: {
          title: 'Часовой пояс',
          inValue: null,
          value: null,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        consent_to_adult_content: {
          title: 'Задания 18+',
          inValue: null,
          value: 0,
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }
      },
      errors: [],
      updateObjectId: null
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, LOAD_FORM_DATA):
        return setRequestStateInProgress(state).merge({
          updateObjectId: action.payload
        });
      case createActionName(name, RECOVERY_FIELDS):
        return storeRecoveryFieldValues(state, action.payload);
      case createActionName(name, SEND_FORM):
        return setRequestStateInProgress(state).merge({
          updateObjectId: action.payload
        });
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state;
      case createActionName(name, CHANGE_FIELD_NAME): {
        return storeSetFieldValue(state, 'name', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_BIRTH_DATE): {
        return storeSetFieldValue(state, 'date', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_BIRTH_MONTH): {
        return storeSetFieldValue(state, 'month', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_BIRTH_YEAR): {
        return storeSetFieldValue(state, 'year', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_GENDER): {
        return storeSetFieldValue(state, 'gender', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_CITY_GEONAME_ID): {
        return storeSetFieldValue(state, 'city_geoname_id', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_TIME_ZONE): {
        return storeSetFieldValue(state, 'time_zone', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_CONSENT_TO_ADULT_CONTENT): {
        return storeSetFieldValue(
          state,
          'consent_to_adult_content',
          action.payload
        );
      }

      case createActionName(name, SET_CITY_GEONAME_ITEM_SELECTED): {
        return state.merge({
          cityGeonameItemSelected: action.payload
        });
      }

      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

export const initState = reducerName => ({
  type: createActionName(reducerName, INIT_STATE)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const loadFormData = (reducerName, payload) => ({
  type: createActionName(reducerName, LOAD_FORM_DATA),
  payload
});
export const recoveryFields = (reducerName, payload) => ({
  type: createActionName(reducerName, RECOVERY_FIELDS),
  payload
});
export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, SEND_FORM),
  payload
});
export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_ERRORS),
  payload
});
export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, CLEAR_ALL_ERRORS),
  payload
});

// FIELDS
export const changeFieldName = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_NAME),
  payload
});
export const changeFieldBirthDate = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_BIRTH_DATE),
  payload
});
export const changeFieldBirthMonth = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_BIRTH_MONTH),
  payload
});
export const changeFieldBirthYear = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_BIRTH_YEAR),
  payload
});
export const changeFieldGender = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_GENDER),
  payload
});
export const changeFieldCityGeonameId = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_CITY_GEONAME_ID),
  payload
});
export const changeFieldTimeZone = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_TIME_ZONE),
  payload
});
export const changeFieldConsentToAdultContent = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_CONSENT_TO_ADULT_CONTENT),
  payload
});

// OTHER
export const setCityGeonameItemSelected = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_CITY_GEONAME_ITEM_SELECTED),
  payload
});

// SELECTOR
export const selectState = (state, reducerName) => getState(state, reducerName);
export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');
export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectAllErrors = (state, reducerName) =>
  _.get(getState(state, reducerName), 'errors');

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');

// Fields
export const selectFieldName = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.name');
export const selectFieldBirthDate = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.date');
export const selectFieldBirthMonth = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.month');
export const selectFieldBirthYear = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.year');
export const selectFieldGender = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.gender');
export const selectFieldCityGeonameId = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.city_geoname_id');
export const selectFieldTimeZone = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.time_zone');
export const selectFieldConsentToAdultContent = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.consent_to_adult_content');

export const selectCityGeonameItemSelected = (state, reducerName) =>
  _.get(getState(state, reducerName), 'cityGeonameItemSelected');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/anketaForm.js